import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { PaginationComponent } from './pagination.component';
import { LoadingModule } from '@web-frontend/shared/components/loading';

@NgModule({
  declarations: [PaginationComponent],
  imports: [CommonModule, TranslateModule.forChild(), LoadingModule],
  providers: [],
  exports: [PaginationComponent],
})
export class PaginationModule {}
